/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Michael Morgan Updates
  class GiftWrapHandler {
    constructor(variantId, checkboxId) {
      this.variantId = variantId;
      this.checkbox = document.getElementById(checkboxId);
      this.cart = {};
      this.initialize();

      
    }

    initialize() {
      this.getCart().then(cart => {
        this.cart = cart;
        this.checkGiftWrapProduct();
        this.setupListeners();
      });
    }

    checkGiftWrapProduct() {
      const giftWrapInCart = this.cart.items.some(item => item.variant_id == this.variantId);
      this.checkbox.checked = giftWrapInCart;
    }

    setupListeners() {
      this.checkbox.addEventListener('change', () => {
        if (this.checkbox.checked) {
          this.addGiftWrapProduct();      
        } else {
          document.querySelector('[data-item-title="Gift Wrapping"] .cart__item__remove').click();  
        }
      });

      this.removeButtonEvent();
    }

    removeButtonEvent() {      
      document.querySelector('[data-cart-drawer-body]').addEventListener('click', (event) => {
        if (event.target.closest('[data-item-title="Gift Wrapping"] .cart__item__remove')) {
          this.checkbox.checked = false;
        }
      })
    }

    addGiftWrapProduct() {
      this.addItemToCart(this.variantId, 1);
    }

    getCart() {
      return fetch('/cart.js')
        .then(response => response.json());
    }

    addItemToCart(variantId, quantity) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        })
      })
      .then(response => response.json())
      .then(updatedCart => {
        this.cart = updatedCart;
        document.dispatchEvent(new Event('gift:wrapping:update:cart'))
      });
    }
  }

  document.addEventListener('DOMContentLoaded', new GiftWrapHandler('30590824316995', 'gift-wrap'));

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
